import React from 'react';

import { EvTableColumn } from '@evinced-private/ui-common';

import { IMfaSessionRow } from 'src/apps/mfa/types/MfaDashboardServiceTypes';
import { DashboardTableLabel } from 'src/common/components/DashboardTableLabel/DashboardTableLabel';
import { EvLinkLocal } from 'src/common/components/ev-link-local/EvLinkLocal';
import { renderNumberCellFormatter } from 'src/common/components/ev-table/cell-formatters/numberCellFormatter';
import { MobilePlatformCellFormatter } from 'src/common/components/mobile-platform-cell-formatter/MobilePlatformCellFormatter';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';
import { applyMobileLabelDisplayNames } from 'src/common/helpers/LabelDisplayHelpers';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { SESSION_COLUMN_STYLE } from './MfaSessionsTable.constants';

const NAME_NOT_PROVIDED = 'Name-not-Provided';

export const getMfaSessionsColumns = (
	unitIdDisplayName?: string,
	environmentDisplayName?: string
): EvTableColumn[] => {
	return [
		{
			dataField: 'sessionName',
			text: 'Session',
			style: SESSION_COLUMN_STYLE,
			headerStyle: SESSION_COLUMN_STYLE,
			sort: true,
			formatter: (displayName: string, session: IMfaSessionRow) => {
				return (
					<EvLinkLocal
						className="mfa-session-name"
						id={session.sessionId}
						url={RoutesHelper.getMfaSessionPath(session.sessionId, SessionViews.OVERVIEW)}
						ariaLabel={`${displayName} Session`}
						linkText={session.sessionName || NAME_NOT_PROVIDED}
						isDark
					/>
				);
			}
		},
		{
			dataField: 'platform',
			text: 'Platform',
			style: { width: '114px' },
			headerStyle: { width: '114px' },
			sort: true,
			formatter: (platforms: string[]) => <MobilePlatformCellFormatter platforms={platforms} />
		},
		{
			dataField: 'totalScans',
			text: 'Scans',
			style: { width: '86px' },
			headerStyle: { width: '86px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'totalIssues',
			text: 'Issues',
			style: { width: '86px' },
			headerStyle: { width: '86px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'criticalIssues',
			text: 'Critical',
			style: { width: '88px' },
			headerStyle: { width: '88px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'lastModified',
			text: 'Last Modified',
			style: { width: '209px' },
			headerStyle: { width: '209px' },
			sort: true,
			formatter: (cell: string): string => formatShortMonthDatetime(cell)
		},
		{
			dataField: 'owner',
			text: 'Owner',
			style: { width: '209px' },
			headerStyle: { width: '209px' },
			sort: true
		},
		{
			dataField: 'labels',
			text: 'Labels',
			style: { width: '209px' },
			headerStyle: { width: '209px' },
			formatter: (labels: string[], session: IMfaSessionRow) => (
				<DashboardTableLabel
					labels={applyMobileLabelDisplayNames(labels, unitIdDisplayName, environmentDisplayName)}
					rowId={session.sessionId}
				/>
			)
		}
	];
};
